import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import type { WizardState } from '../api';
import { Button, Card, Pill } from '../ui/primitives';

export function StepDone({ wizard }: { wizard: WizardState }) {
  const qc = useQueryClient();
  const finish = useMutation({
    mutationFn: () => api.post<WizardState>('/api/wizard/complete'),
    onSuccess: () => void qc.invalidateQueries(),
  });

  return (
    <Card>
      <h2 className="text-lg font-semibold">Ready to import your first week</h2>
      <p className="mt-1 text-caption text-ink-muted">
        All wizard steps show <Pill tone="green">complete</Pill>. You can
        continue editing parties, accounts, aliases, and balances any time —
        the wizard is just a guided first pass.
      </p>

      <ul className="mt-4 space-y-1 text-sm">
        <li>• {wizard.counts.uplineParties} upline(s)</li>
        <li>• {wizard.counts.clientParties} client(s)</li>
        <li>• {wizard.counts.accounts} account(s)</li>
        <li>• {wizard.counts.aliases} active alias(es)</li>
        <li>• {wizard.counts.assignments} assignment(s)</li>
        <li>• {wizard.counts.openingBalances} opening balance(s)</li>
      </ul>

      {!wizard.completed && (
        <div className="mt-4">
          <Button onClick={() => finish.mutate()}>Finish setup</Button>
        </div>
      )}
      {wizard.completed && (
        <p className="mt-4 text-sm text-pos">Setup complete.</p>
      )}
    </Card>
  );
}
